import React, { Component } from 'react'
import Dummy from '../../../assets/image/event/corpu/corpu_cover.jpg'
import event2 from '../../../assets/image/event2.jpg'
import Chevron from '../../../assets/image/chevron-white.png'
import './style.css'
import {Button} from '@material-ui/core'
import Download from '../../../assets/image/Download.svg'
import { MuiThemeProvider, createMuiTheme,withStyles, } from '@material-ui/core/styles'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton'
import NoImage from '../../../assets/image/no_image.png'

const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#FFFFFF',
        },
    } 
})
export default class banner1 extends Component {
    renderCategory=(id)=>{
        switch (id) {
            case '1':
                return 'Mega Seminar'
                // break;
            case '2':
                return 'Public Workshop'
            case '3':
                return 'Webinar'
            case '4':
                return 'Blended learning'
            default:
                break;
        }
    }
    render() {
    const {event,loading}=this.props

        return (
            <div>
                <div className='banner1-wrapper-desktop'>
                    <img src={event2}/>
                    <div className='banner-content'>
                        {event!==null&&
                        <div className='event-breadchrum'>
                            <p><a href="#" onClick={()=>window.location.assign('/event-list')}>Event & webinar</a></p>
                            &nbsp;
                            <img src={Chevron} className='breadchrum-chevron'/>
                            &nbsp;
                            <p>{event.event.title}</p>
                            
                        </div>
                        }
                        <div className='banner-content-thumbnail'>
                            <img src={event.thumbnail.url!==null?event.thumbnail.url:NoImage}/>
                        </div>
                        <div className='banner-content-description'>
                            
                            <>
                            <h1>{event.event.title}</h1>
                            <p>{event.category.text} {event.event.fromDate===event.event.toDate?moment(event.event.fromDate).format('D MMM YYYY'):`${moment(event.event.fromDate).format('D MMM')} - ${moment(event.event.toDate).format('D MMM YYYY')}`} {event.event.address}</p>
                            </>

                        </div>
                        <div className='banner-content-audience'>
                           
                            <>
                            <b>Target Audience</b>
                            <p>{event.event.audience}</p>
                            </>
                        </div>
                    </div>
                   
                </div>
                <div>
               
                <>
                <div className='banner1-wrapper-mobile'>
                    <img src={event2}/>
                    <div className='banner-content-mobile'>
                        <div className='breadcrum-event-webinar'>
                        <p><a href="#" onClick={()=>window.location.assign('/event-list')}>Event & webinar</a></p>
                            &nbsp;
                            <img src={Chevron} className='breadchrum-chevron'/>
                            &nbsp;
                            <p>{event.event.title.substring(0,30)}</p>
                            
                        </div>
                        {/* <div> */}
                        <h1>{event.event.title}</h1>
                        <div style={{display:'flex',justifyContent:'space-between'}}>
                        <p>{event.category.text} {event.event.fromDate===event.event.toDate?moment(event.event.fromDate).format('D MMM YYYY'):`${moment(event.event.fromDate).format('D MMM')} - ${moment(event.event.toDate).format('D MMM YYYY')}`} {event.event.address}</p>
                            <MuiThemeProvider theme={themeButton}>
                                {event.category.id!==2&&<Button color='primary' className='btn-remove-capital' size='small' variant='text' startIcon={<img src={Download} style={{width:15}} onClick={()=>this.props.toggleRequest(event.event.title)}/>}>Brochure</Button>}
                            </MuiThemeProvider>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
                <div className='audience-mobile'>
                    <br/>
                    <h3>Target Audience</h3>
                    <br/>
                    <p>{event.event.audience}</p>
                </div>
                </>

             </div>
            </div>
        )
    }
}
